import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {ProductFeature} from '../types';
import {useNavigate} from "react-router-dom";
import {stage} from "../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                           }: {
    record: Omit<ProductFeature, 'id'>,
    handleSubmit: (values: ProductFeature) => void
}) => {
    const navigate = useNavigate()

    const onSubmit = (values: ProductFeature) => {

        console.debug(values)

        handleSubmit(values);
        navigate('/product-features');
    };

    const onCancel = () => {
        navigate('/product-features');
    };


    let initialValues = {} as ProductFeature;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent />
                </FormWithButtons>)}
        </Formik>
    );
};
